// Mock data for Brains On Tap clone

export const nextEvent = {
  label: "NEXT BOT EVENT:",
  text: "Wednesday, July 29th 6-8PM @ TWB Brewing - Kitchener",
};

export const navLinks = [
  { label: "Home", to: "/" },
  { label: "Why?", to: "/why" },
  {
    label: "Community",
    to: "#",
    children: [
      { label: "Become a Speaker", to: "/become-a-speaker" },
      { label: "Become a Volunteer", to: "/become-a-volunteer" },
      { label: "Host a BOT Event", to: "/host-a-bot-event" },
    ],
  },
  { label: "BOT Events", to: "/bot-events" },
  { label: "Speaker Bios", to: "/speaker-bios" },
];

export const heroImage =
  "https://images.unsplash.com/photo-1666282020483-6ebeb210b1c3?auto=format&fit=crop&w=1920&q=80";

export const aboutImage =
  "https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&w=1200&q=80";

export const whyCards = [
  {
    title: "Origin Story",
    image:
      "https://images.unsplash.com/photo-1664382951821-8151535191e5?auto=format&fit=crop&w=800&q=80",
    short:
      "Brains on Tap was founded by a college professor in Ontario, Canada who saw firsthand how disconnected and outdated our education system had become.",
    full: "Brains on Tap was founded by a college professor in Ontario, Canada who saw firsthand how disconnected and outdated our education system had become. Craving more meaningful connection, she envisioned a space where real people could share real ideas in a way that felt human, informal, and inspiring. After discovering a similar concept running out of NYC, she reimagined how it could work in Canada—with a twist. Because let's be honest: our higher education system is a flaming dumpster fire, and this is the kind of learning actually worth tapping into.",
  },
  {
    title: "Our Mission",
    image:
      "https://images.unsplash.com/photo-1532634922-8fe0b757fb13?auto=format&fit=crop&w=800&q=80",
    short:
      "Brains on Tap exists to make learning social, accessible, and deeply human.",
    full: "Brains on Tap exists to make learning social, accessible, and deeply human. We create space for real people to share real ideas in welcoming, non-traditional environments—like breweries and pubs. Our mission is to reimagine what education can look like by blending curiosity, conversation, and community—one non-lecture at a time. Our mission is to empower individuals with the knowledge and skills they need to succeed in life.",
  },
  {
    title: "Our Approach",
    image:
      "https://images.unsplash.com/photo-1592861956120-e524fc739696?auto=format&fit=crop&w=800&q=80",
    short:
      "We believe that learning should be engaging, interactive, and fun.",
    full: "We believe that learning should be engaging, interactive, and fun. That's why we have developed a unique approach to education that combines non-traditional teaching methods within relaxed social settings. We strive to create a supportive learning community that fosters growth, creativity, and innovation. For every BOT event, we are committed to helping life-long learners nerd-out, achieve their goals and reach their full human potential.",
  },
  {
    title: "Our Team",
    image:
      "https://images.unsplash.com/photo-1517486808906-6ca8b3f04846?auto=format&fit=crop&w=800&q=80",
    short:
      "Our team consists of experienced educators, storytellers, subject matter experts, creatives, and entrepreneurs who are passionate about education.",
    full: "Our team consists of experienced educators, storytellers, subject matter experts, creatives, and entrepreneurs who are passionate about education. We are dedicated to providing the best possible learning experience for our BOT Community. They are individuals who are committed to staying at the forefront of building community around educational innovation. Our team is comprised of speakers, volunteers and community partners. This community is ever-changing and ever evolving.",
  },
];

export const speakers = [
  {
    name: "Sean Geobey",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&w=800&q=80",
    bio: "Sean Geobey is an academic, researcher, and self-described Man About Town who spends a lot of time thinking about how people work, learn, and solve problems together. An Associate Professor at the University of Waterloo, his work focuses on social innovation, collective action, and participatory approaches to complex problems. His teaching is rooted in problem-based and community-engaged learning, which makes Sean the perfect person to ask:",
    topic: "Are lectures really the best way for us to learn?",
  },
  {
    name: "Shannon Knelsen",
    image:
      "https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&w=800&q=80",
    bio: "Shannon Knelsen is a healthcare leader, educator, and the Founder Brain behind the Brains On Tap mission. Passionate about lifelong learning and community connection, she created Brains On Tap to bring engaging conversations out of the classroom and into local gathering spaces in the Tri-Cities/Waterloo Region. Her mission is simple: Turn small talk into smart conversations and to create a place where nerdy people go to have fun. The first BOT speaker event will be delivered by Shannon on July 12th, 2026, where she'll discuss:",
    topic: "What the Healthcare, Canada?",
  },
];

export const speakerReasons = [
  {
    title:
      "You consider yourself a passionate storyteller, educator, or subject matter expert, and you are drawn to public speaking.",
    image:
      "https://images.unsplash.com/photo-1475721027785-f74eccf877e2?auto=format&fit=crop&w=800&q=80",
    body: "At BOT: The Non-Lecture Experience, we believe that education is the key to unlocking human potential. We strive to create a relaxed and 'zero pressure' learning environments that are inclusive, collaborative, and supportive. We recognize that every individual has unique talents and strengths. Some are speakers, and some are the learners. Either way, we're all BRAINS!",
  },
  {
    title:
      "You are curious about new ways of information sharing, and building community around dynamic experiences with life-long learning.",
    image:
      "https://images.unsplash.com/photo-1543269865-cbf427effbad?auto=format&fit=crop&w=800&q=80",
    body: "We offer a wide range of themed speaker events that cater to the diverse areas of interests from our community members. Each 'meeting of the brains' would be considered an exchange of knowledge, skills, real world story telling. Consider these lessons that humans really need to survive in life or career. The idea is that attendees are taking away both practical and emotional intelligence.",
  },
  {
    title:
      "You are building your reputation as a thought leader who is contributing to making real world learning accessible, human and fun.",
    image:
      "https://images.unsplash.com/photo-1560439514-4e9645039924?auto=format&fit=crop&w=800&q=80",
    body: "In a world flooded with content, true thought leaders stand out not just for what they know—but for how they connect. Now more than ever, we need voices that are authentic, human, and rooted in real-world experience. Brains on Tap gives emerging and established thought leaders a space to practice public speaking, refine their message, and make a positive impact—one conversation at a time.",
  },
];

export const speakerFaqs = [
  {
    q: "What are the qualifications of your BOT Speakers?",
    a: "Our BOT Speakers are considered highly qualified and/or experienced in their respective fields or area of interest. Many of them come with both lived and professional experience. They are known by their peers as natural storytellers and they have the ability to hold the attention of an audience. You do not need any specific level of academic achievement in order to be considered a Speaker for Brains On Tap. BOT Speakers will go through a brief training prior to their first event, to ensure they are comfortable with the process.",
  },
  {
    q: "How long are the BOT events?",
    a: "Each 'Meeting of the Brains' or BOT Non-Lecture experience is a 45-min. to 1hr talk from the speaker + 15-minutes for Q&A + 45-minutes for mingling and networking with the speaker and other attendees. Total approx. 2hrs.",
  },
  {
    q: "What sort of topics are you featuring with BOT?",
    a: "The opportunities here are endless, however, here is a list of topics we've considered so far: The Psychology of Perseverance: Why Some People Keep Going; Burnout, Breakdowns & Breakthroughs: What They Don't Teach You in Self-Help Books; The History of LEGO and the Power of Play in Adulthood; Why We Self-Sabotage (And How to Stop); Cheap Wine vs. Expensive Wine: Can You Really Taste the Difference?; Imposter Syndrome and the Myth of Confidence; What Ancient Philosophers Got Right About Modern Anxiety; The Neuroscience of Motivation: What Actually Gets You Moving; How Failing at Something Can Be the Best Thing That Happens to You.",
  },
];

export const volunteerReasons = [
  {
    title: "You're looking for something a little different.",
    image:
      "https://images.unsplash.com/photo-1758275557354-00904e39c6da?auto=format&fit=crop&w=800&q=80",
    body: "If you're curious, community-minded, and excited about shaking up the way we learn and connect over life-long learning. Whether you love event planning, hosting, promoting events, designing merch, or just being part of something meaningful (and fun), there's a place for you here. This isn't your typical volunteer gig... and that's exactly the appeal.",
  },
  {
    title: "You have a strong sense of community.",
    image:
      "https://images.unsplash.com/photo-1592861956120-e524fc739696?auto=format&fit=crop&w=800&q=80",
    body: "You believe learning should feel like a conversation, not a chore. You want to help build a community that values curiosity, connection, and real human stories. You see volunteering as a chance to be part of something fresh, meaningful, and fun—while gaining experience, meeting interesting people, and helping reimagine what education and learning can look like at the community level.",
  },
  {
    title: "You are looking to develop your skills.",
    image:
      "https://images.unsplash.com/photo-1528605248644-14dd04022da1?auto=format&fit=crop&w=800&q=80",
    body: "Helping with BOT is a great way to build real-world skills in a creative, community-focused environment. You'll gain hands-on experience in event planning, public speaking, marketing, networking, and community engagement—all while being part of a team that values innovation, curiosity, and human connection. Whether you're helping behind the scenes or taking the mic as an emcee, you'll grow your confidence, communication skills, and leadership abilities in a setting that's anything but traditional.",
  },
];

export const partners = [
  {
    name: "TWB Brewing Co-Op - Kitchener",
    image:
      "https://images.unsplash.com/photo-1571168136613-46401b03904e?auto=format&fit=crop&w=800&q=80",
    body: "TWB Cooperative Brewing is a community-minded craft brewery in Kitchener that believes great ideas are best shared over a drink. As Brains On Tap's founding venue partner, TWB is helping create a welcoming space where curiosity, conversation, and community come together.",
  },
  {
    name: "Midtown Radio - Waterloo Region",
    image:
      "https://images.unsplash.com/photo-1487215078519-e21cc028cb29?auto=format&fit=crop&w=800&q=80",
    body: "Midtown Radio is a community-driven, volunteer-powered radio station that celebrates local voices and the stories that bring our community together. As a supportive partner of Brains On Tap, Midtown Radio shares our belief that great conversations have the power to educate, inspire, and connect people—both on-air and in person.",
  },
];

export const contact = {
  phone: "226-752-8140",
  email: "brainsontapcanada@gmail.com",
};

export const socials = [
  { name: "Facebook", url: "https://www.facebook.com/profile.php?id=61577320844492" },
  { name: "Instagram", url: "https://www.instagram.com/brains.on.tap.canada/" },
  { name: "LinkedIn", url: "https://www.linkedin.com/company/brains-on-tap-canada/?viewAsMember=true" },
  { name: "YouTube", url: "https://www.youtube.com/@BrainsOnTapCanada" },
];
